export const referSchemeTranslations = {
    en: {
        // Page Title
        schemesReferredFor: "Schemes Referred for",
        allCampaigns: "All Campaigns",

        // Table Headers
        srNo: "Sr No",
        tokenNo: "Token No",
        beneficiaryName: "Beneficiary Name",
        schemes: "Schemes",
        remark: "Remark",
        action: "Action",

        // Buttons
        schemeDetails: "Scheme Details",
        shareScheme: "Share Scheme",
        viewProfile: "View Profile",

        // Status
        campCompleted: "Camp Completed",

        // Drawer Titles
        addSchemesReferal: "Add Schemes Referal",

        // Tooltips
        noSchemesAvailable: "No schemes available",

        // Common
        notAvailable: "N/A",
        unknown: "Unknown",

        // Module Name
        schemesReferredModule: "Schemes Referred",
    },
    mr: {
        // Page Title
        schemesReferredFor: " योजनासाठी संदर्भित",
        allCampaigns: "सर्व मोहिमा",

        // Table Headers
        srNo: "अ. क्र.",
        tokenNo: "टोकन क्रमांक",
        beneficiaryName: "लाभार्थीचे नाव",
        schemes: "योजना",
        remark: "शेरा",
        action: "क्रिया",

        // Buttons
        schemeDetails: "योजना तपशील",
        shareScheme: "योजना सामायिक करा",
        viewProfile: "प्रोफाइल पहा",

        // Status
        campCompleted: "शिबिर पूर्ण झाले",

        // Drawer Titles
        addSchemesReferal: "योजना संदर्भ जोडा",

        // Tooltips
        noSchemesAvailable: "योजना उपलब्ध नाहीत",

        // Common
        notAvailable: "उपलब्ध नाही",
        unknown: "अज्ञात",

        // Module Name
        schemesReferredModule: "योजना संदर्भित",
    }
};
